import styled from 'styled-components'

// Components
import { Button } from '@sketch/components'

export const StyledButton = styled(Button)`
  flex: 1;
`
